import { Avatar, Box, Stack, Typography } from '@mui/material';
import { getGeneralOptions } from 'API/generalOptions/generalOptions';
import { ControlledRadioButtons } from 'Components/ControlledRadioButtons';
import { OTPLoginContext } from 'Context/OTPLoginContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDictionary, useDispatchApp } from 'Hooks';
import { UniversalRequestFullPurpleExclamationMark } from 'Images';
import { setGeneralOptions } from 'Store';
import { useCallback, useContext, useEffect } from 'react';

interface IValidationSelector {
  isEmail: boolean;
  setIsEmail: Function;
}

export const ValidationSelector = ({
  isEmail,
  setIsEmail,
}: IValidationSelector) => {
  const { userDetails } = useContext(OTPLoginContext);

  const dispatch = useDispatchApp();
  const { generalOptions } = useAppSelector((state) => state.generalOptions);
  const initializeGeneralOptions = useCallback(async () => {
    if (!generalOptions) {
      const generalOptionsResult = await getGeneralOptions();
      if (generalOptionsResult) {
        dispatch(setGeneralOptions(generalOptionsResult));
      }
    }
  }, [dispatch, generalOptions]);

  useEffect(() => {
    initializeGeneralOptions();
  }, [initializeGeneralOptions]);

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.OTP_Login
  ).phoneEmailValidation;

  return (
    <Stack direction='column' alignItems='center' mb='64px'>
      <ControlledRadioButtons
        isDirectionRow
        title={dictionary.sendCodeTo}
        radioGroupSx={{ gap: '37px' }}
        values={[dictionary.phone, dictionary.email]}
        onChange={(value: string) => setIsEmail(value === dictionary.email)}
        ariaDescribedBy='radio-group-description'
      />
      {(isEmail && userDetails.email.trim() !== '') || !isEmail ? (
        <Typography
          sx={{
            mt: '24px',
            fontFamily: 'inherit',
          }}
          variant='body2'
          id='radio-group-description'
        >
          {dictionary.willBeSentTo}{' '}
          <Box component='span' style={{ fontWeight: 'bold' }}>
            {isEmail
              ? userDetails.email
              : `${userDetails.phonePrefix}-${userDetails.phoneNumber}`}
          </Box>
        </Typography>
      ) : (
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='center'
          columnGap='6px'
          flexWrap='wrap'
          mt='24px'
          role='alert'
        >
          <Avatar
            sx={{ width: '24px', height: '24px' }}
            src={UniversalRequestFullPurpleExclamationMark}
            alt=''
          />
          <Typography variant='body2' lineHeight='24px'>
            {dictionary.missingMail[0]}
          </Typography>
          <Typography variant='body2' lineHeight='24px'>
            {dictionary.missingMail[1]}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};
